var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { getColorScheme } from '../../Hooks/UseColorScheme';
let ProgressBarStepView = class ProgressBarStepView extends Component {
    constructor() {
        super(...arguments);
        this.handlePress = () => {
            return typeof this.props.onPress === 'function' && this.props.onPress(this.props.value);
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return (_jsx(Pressable, { testID: `button-${this.props.value.title}`, style: [(_a = this.props.style) === null || _a === void 0 ? void 0 : _a.stepContainer], onPress: this.handlePress, children: _jsxs(View, { style: [(_b = this.props.style) === null || _b === void 0 ? void 0 : _b.step], children: [_jsx(View, { style: { minHeight: this.props.dimensions.iconSize }, children: (!!this.props.value.image || !!this.props.value.icon) && (_jsx(AnimatedImageView, { image: this.props.value.image, icon: this.props.value.icon, containerStyle: { width: this.props.dimensions.iconSize, height: this.props.dimensions.iconSize }, color: this.props.isActive ? (_d = (_c = this.props.style) === null || _c === void 0 ? void 0 : _c.activeText) === null || _d === void 0 ? void 0 : _d.color : (_f = (_e = this.props.style) === null || _e === void 0 ? void 0 : _e.text) === null || _f === void 0 ? void 0 : _f.color })) }), _jsx(View, { style: [(_g = this.props.style) === null || _g === void 0 ? void 0 : _g.stepPoint, { marginVertical: this.props.dimensions.circleMargin, width: this.props.dimensions.circleSize, height: this.props.dimensions.circleSize }, this.props.isActive && ((_h = this.props.style) === null || _h === void 0 ? void 0 : _h.stepPointActive)] }), _jsx(View, { style: (_j = this.props.style) === null || _j === void 0 ? void 0 : _j.textContainer, children: !!this.props.value.title && (_jsx(AnimatedTextView, { textStyle: [(_k = this.props.style) === null || _k === void 0 ? void 0 : _k.text, this.props.isActive && ((_l = this.props.style) === null || _l === void 0 ? void 0 : _l.activeText)], children: this.props.value.title })) })] }) }));
    }
};
ProgressBarStepView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.progressBarStep,
        style: (theme, mediaQuery) => {
            var _a, _b, _c, _d;
            return StyleSheet.create({
                stepContainer: {
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                step: {
                    alignItems: 'center'
                },
                stepPoint: {
                    borderRadius: 16,
                    backgroundColor: ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.link_color) || '#DBE2EB'
                },
                stepPointActive: {
                    backgroundColor: ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgba(17, 85, 204, 1)',
                },
                textContainer: {
                    alignItems: 'center',
                    minHeight: 18
                },
                text: Object.assign({ textAlign: 'center', fontSize: 14, lineHeight: 18, color: getColorScheme().value.scheme === 'dark'
                        ? '#fff'
                        : ((_c = theme.colors) === null || _c === void 0 ? void 0 : _c.text_color) || '#394E66', fontWeight: 'normal', maxWidth: 65 }, mediaQuery.md({
                    maxWidth: undefined
                })),
                activeText: {
                    color: ((_d = theme.colors) === null || _d === void 0 ? void 0 : _d.secondary_color) || 'rgba(17, 85, 204, 1)',
                    fontWeight: 'bold'
                }
            });
        }
    })
], ProgressBarStepView);
export { ProgressBarStepView };
